import Header from './components/Header';
import Hero from './components/Hero';
import SectionCarousel from './components/SectionCarousel';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionRanking from './components/SectionRanking';
import SectionFeatures from './components/SectionFeatures';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import SectionTopics from './components/SectionTopics';
import SectionContact from './components/SectionContact';
import SectionMedia from './components/SectionMedia';
import SectionFaq from './components/SectionFaq';
import SectionAbout from './components/SectionAbout';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionCarousel />
        <SectionUpdates />
        <SectionCards />
        <SectionIndex />
        <SectionRanking />
        <SectionFeatures />
        <SectionApp />
        <SectionComments />
        <SectionTopics />
        <SectionContact />
        <SectionMedia />
        <SectionFaq />
        <SectionAbout />
      </main>
      <Footer />
    </>
  );
}